import styled from '@emotion/styled';
import { MEDIA_QUERIES } from 'radiance-ui/lib/constants';

import { LOCAL_COLORS } from 'styles/constants';

export const GlyphContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: nowrap;
  padding-bottom: 1.5rem;
  flex: 1;
`;

export const ImageContainer = styled.div`
  width: 70px;
`;

export const NameContainer = styled.div`
  padding-top: 1.5rem;
  font-size: 1rem;
  font-weight: 700;
  line-height: 130%;
  color: ${LOCAL_COLORS.textInverse};
  text-align: center;
  min-width: 100px;

  ${MEDIA_QUERIES.xlUp} {
    padding-top: 2rem;
    font-size: 1.5rem;
  }
`;
